import { Injectable, signal } from '@angular/core';

interface CallLog {
  activations: Date[];
  deactivations: Date[];
  activeStatus: boolean;
  loaders: Set<string>;
}

@Injectable({
  providedIn: 'root',
})
export class GlobalLoadersService {
  private readonly activeLoaders = signal(new Set<string>());
  private readonly callLogs: Record<string, CallLog> = {};

  public isActive(loader: string): boolean {
    return this.activeLoaders().has(loader);
  }

  public setActive(caller: string, loaders: string | string[]): void {
    if (!Array.isArray(loaders)) {
      loaders = [loaders];
    }
    const currentLog = this.getLog(caller);

    currentLog.activations.push(new Date());
    currentLog.activeStatus = true;
    loaders.forEach((loader) => currentLog.loaders.add(loader));

    this.updateSignal();
  }

  public setInactive(caller: string, loaders: string | string[]): void {
    if (!Array.isArray(loaders)) {
      loaders = [loaders];
    }
    const currentLog = this.getLog(caller);

    currentLog.deactivations.push(new Date());
    currentLog.activeStatus = false;
    loaders.forEach((loader) => currentLog.loaders.delete(loader));

    this.updateSignal();
  }

  private updateSignal(): void {
    const newList = new Set<string>();

    for (const callLog of Object.values(this.callLogs)) {
      if (callLog.activeStatus) {
        callLog.loaders.forEach((loader) => newList.add(loader));
      }
    }
    this.activeLoaders.set(newList);
  }

  private getLog(callerName: string): CallLog {
    if (!Object.hasOwn(this.callLogs, callerName)) {
      this.callLogs[callerName] = {
        activations: [],
        deactivations: [],
        activeStatus: false,
        loaders: new Set(),
      };
    }

    return this.callLogs[callerName];
  }
}
